export default {
  //ip: {
  //  protocolo: "http",
  //  //backendIp: "172.17.2.24",
  //  backendIp: "127.0.0.1",
  //  backendPort: ":5004"
  //},
  ip: {
      protocolo: "https",
      backendIp: "pesquisalpr.eletrosinaltec.com.br/acesso",
      backendPort: ""
  },
  pagesize: 10,
  idleVue: {
    isIdle: true
  },
  monitorar: "",
}